export const PRIVACY_POLICY_LINK = 'https://gokyg.com/privacy';
export const TERMS_OF_SERVICE_LINK = 'https://gokyg.com/terms';
